export default {
  STATUS: [
    { KEY: 1, VALUE: 'ATIVO' },
    { KEY: 0, VALUE: 'INATIVO' },
  ],
  WAYS: [
    { KEY: 0, VALUE: 'IDA' },
    { KEY: 1, VALUE: 'VOLTA' },
  ],
  PATH_TYPES: [
    { KEY: 0, VALUE: 'IDA' },
    { KEY: 1, VALUE: 'IDA E VOLTA' },
  ],
  MODES: [
    { KEY: 0, VALUE: 'URBANO' },
    { KEY: 1, VALUE: 'INTERMUNICIPAL' },
    { KEY: 2, VALUE: 'INTERESTADUAL' },
  ],
  LINE_DISTRIBUTION_TYPES: [
    { KEY: 0, VALUE: 'REDE RADIAL' },
    { KEY: 1, VALUE: 'REDE EM MALHA' },
    { KEY: 2, VALUE: 'REDE BRT' },
  ],
  LINE_TYPES: [
    { KEY: 0, VALUE: 'DIAMETRAL' },
    { KEY: 1, VALUE: 'PERIMETRAL' },
    { KEY: 2, VALUE: 'RADIAL' },
    { KEY: 3, VALUE: 'LOCAL' },
    { KEY: 4, VALUE: 'CIRCULAR' },
  ],
  LINE_FUNCTIONS: [
    { KEY: 0, VALUE: 'CONVENCIONAL' },
    { KEY: 1, VALUE: 'ALIMENTADORA' },
    { KEY: 2, VALUE: 'TRONCAL' },
    { KEY: 3, VALUE: 'EXPRESSA' },
    { KEY: 4, VALUE: 'ESPECIAL' },
    { KEY: 5, VALUE: 'EXECUTIVO' },
    { KEY: 6, VALUE: 'RURAL' },
    { KEY: 7, VALUE: 'ESCOLAR' },
    { KEY: 8, VALUE: 'CORUJÃO' },
  ],
  TARIFF_PROFILE: [
    { KEY: 0, VALUE: 'TARIFA ÚNICA' },
    { KEY: 1, VALUE: 'SECCIONADO' },
    { KEY: 2, VALUE: 'SECCIONADO ÚNICO' },
  ],
  LINE_OPERATION: [
    { KEY: 0, VALUE: 'Ônibus' },
    { KEY: 1, VALUE: 'Mêtro' },
    { KEY: 2, VALUE: 'Balsa' },
  ],
};

export const CONST_LINES_OBJECT = {
  STATUS: {
    ACTIVE: { KEY: 1, VALUE: 'ATIVO' },
    INACTIVE: { KEY: 0, VALUE: 'INATIVO' },
  },
  WAYS: {
    GO: { KEY: 0, VALUE: 'IDA' },
    BACK: { KEY: 1, VALUE: 'VOLTA' },
  },
  PATH_TYPES: {
    ONLY_GO: { KEY: 0, VALUE: 'IDA' },
    GO_BACK: { KEY: 1, VALUE: 'IDA E VOLTA' },
  },
  MODES: {
    URBAN: { KEY: 0, VALUE: 'URBANO' },
    INTERMUNICIPAL: { KEY: 1, VALUE: 'INTERMUNICIPAL' },
    INTERSTATE: { KEY: 2, VALUE: 'INTERESTADUAL' },
  },
  LINE_DISTRIBUTION_TYPES: {
    RADIAL: { KEY: 0, VALUE: 'REDE RADIAL' },
    MESH: { KEY: 1, VALUE: 'REDE EM MALHA' },
    BRT: { KEY: 2, VALUE: 'REDE BRT' },
  },
  LINE_TYPES: {
    DIAMETRAL: { KEY: 0, VALUE: 'DIAMETRAL' },
    PERIMETRAL: { KEY: 1, VALUE: 'PERIMETRAL' },
    RADIAL: { KEY: 2, VALUE: 'RADIAL' },
    LOCAL: { KEY: 3, VALUE: 'LOCAL' },
    CIRCULAR: { KEY: 4, VALUE: 'CIRCULAR' },
  },
  LINE_FUNCTIONS: {
    COMMON: { KEY: 0, VALUE: 'CONVENCIONAL' },
    FEEDER: { KEY: 1, VALUE: 'ALIMENTADORA' },
    TRONCAL: { KEY: 2, VALUE: 'TRONCAL' },
    EXPRESS: { KEY: 3, VALUE: 'EXPRESSA' },
    SPECIAL: { KEY: 4, VALUE: 'ESPECIAL' },
    EXECUTIVE: { KEY: 5, VALUE: 'EXECUTIVO' },
    RURAL: { KEY: 6, VALUE: 'RURAL' },
    SCHOOLAR: { KEY: 7, VALUE: 'ESCOLAR' },
    NIGHT: { KEY: 8, VALUE: 'CORUJÃO' },
  },
  TARIFF_PROFILE: {
    NORMAL: { KEY: 0, VALUE: 'NORMAL' },
    SECTIONED: { KEY: 1, VALUE: 'SECCIONADO' },
    SECTIONED_SINGLE: { KEY: 2, VALUE: 'SECCIONADO ÚNICO' },
  },
  GEOJSON_PROPS: {
    TYPES: {
      STOPPING_POINT: { KEY: 0, VALUE: 'PONTO DE PARADA' },
      ROUTING_POINT: { KEY: 1, VALUE: 'PONTO DE ROTEIRIZAÇÃO' },
      ROUTE_LINE: { KEY: 2, VALUE: 'ROTA' },
    },
  },
};
